module.exports = __webpack_public_path__ + "media/site_templates/www.removingasbestos.net.au/images/about_us-6c48a072f9a11bd10518d96fc8a4131b.jpg";